import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check for existing session on app load
  useEffect(() => {
    const token = localStorage.getItem('qh-admin-token');
    const expiry = localStorage.getItem('qh-admin-expiry');
    
    if (token && expiry) {
      const now = new Date().getTime();
      if (now < parseInt(expiry)) {
        setIsAuthenticated(true);
      } else {
        // Token expired, clear storage
        localStorage.removeItem('qh-admin-token');
        localStorage.removeItem('qh-admin-expiry');
      }
    }
    setLoading(false);
  }, []);

  const login = (username, password) => {
    // Simple hardcoded authentication for now
    // In production, this would call an API
    const validCredentials = {
      username: 'qhadmin',
      password: 'Queens2024!Admin'
    };

    if (username === validCredentials.username && password === validCredentials.password) {
      const token = 'admin-session-' + Date.now();
      const expiry = new Date().getTime() + (24 * 60 * 60 * 1000); // 24 hours
      
      localStorage.setItem('qh-admin-token', token);
      localStorage.setItem('qh-admin-expiry', expiry.toString());
      setIsAuthenticated(true);
      return { success: true };
    }

    return { success: false, error: 'Invalid username or password' };
  };

  const logout = () => {
    localStorage.removeItem('qh-admin-token');
    localStorage.removeItem('qh-admin-expiry');
    setIsAuthenticated(false);
  };

  const value = {
    isAuthenticated,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};